/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var $window = $(window);
	var breakPoint = 1024;
	
	var resizeFlag = false;
	var windowWidth = $window.width();
	var windowHeight = $window.height();
	
	//ローディング
	
	(0, _module.loading)();
	
	//ヘッダーの開閉
	
	(0, _module.headerToggle)();
	
	//ページ内リンクのアニメーション
	
	(0, _module.anchorScroll)();
	
	// preload
	
	(0, _module.preload)();
	
	// resizing
	
	(0, _module.resizing)();
	
	// アニメーション
	
	(0, _module.animationFire)();
	
	//タブ切り替え
	var story_Tab = function story_Tab() {
	  var $tabNav = $('.story-Tab').find('li');
	  var $st_Wrapper = $('.st-Wrapper');
	  $tabNav.on('click', function () {
	    $($tabNav).removeClass('current');
	    // $(this).addClass('current');
	    // $($st_Wrapper).toggleClass('season1');
	    // $($st_Wrapper).toggleClass('season2');
	    var element = this.className;
	    $(this).addClass('current');
	    if (element == 'season1') {
	      $($st_Wrapper).addClass('season1');
	      $($st_Wrapper).removeClass('season2');
	      $($st_Wrapper).removeClass('season3');
	    } else if (element == 'season2') {
	      $($st_Wrapper).addClass('season2');
	      $($st_Wrapper).removeClass('season1');
	      $($st_Wrapper).removeClass('season3');
	    } else if (element == 'season3') {
	      $($st_Wrapper).addClass('season3');
	      $($st_Wrapper).removeClass('season1');
	      $($st_Wrapper).removeClass('season2');
	    }
	    $('.swiper-container').each(function () {
	      var mySwiper = new Swiper(this, {
	        // Optional parameters
	        autoplay: {
	          delay: 5000,
	          disableOnInteraction: false
	        },
	        slidesPerView: 3,
	        spaceBetween: windowWidth * 0.0078125,
	        direction: 'horizontal',
	        loop: true,
	        pagination: {
	          el: '.swiper-pagination',
	          clickable: true
	        },
	        navigation: {
	          nextEl: '.swiper-button-next',
	          prevEl: '.swiper-button-prev'
	        },
	        breakpoints: {
	          1024: {
	            slidesPerView: 1,
	            spaceBetween: 0
	          }
	        }
	      });
	    });
	  });
	};
	story_Tab();
	
	// swiper
	$('.swiper-container').each(function () {
	  var mySwiper = new Swiper(this, {
	    // Optional parameters
	    autoplay: {
	      delay: 5000,
	      disableOnInteraction: false
	    },
	    slidesPerView: 3,
	    spaceBetween: windowWidth * 0.0078125,
	    direction: 'horizontal',
	    loop: true,
	    pagination: {
	      el: '.swiper-pagination',
	      clickable: true
	    },
	    navigation: {
	      nextEl: '.swiper-button-next',
	      prevEl: '.swiper-button-prev'
	    },
	    breakpoints: {
	      1024: {
	        slidesPerView: 1,
	        spaceBetween: 0
	      }
	    }
	  });
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $window = $(window);
	// const breakPoint = 767;
	var breakPoint = 1199;
	
	var resizeFlag = false;
	var windowWidth = $window.width();
	var windowHeight = $window.height();
	
	var url = location.href;
	
	//ローディング
	var loading = function loading() {
	  $(window).on('load', function () {
	    $("#loading").addClass("loaded");
	
	    setTimeout(function () {
	      var $modalAfterLoad = $(".modal-AfterLoad");
	      if ($modalAfterLoad) {
	        $modalAfterLoad.click();
	      }
	    }, 500);
	  });
	};
	
	//ヘッダーの開閉
	var headerToggle = function headerToggle() {
	  //toggle
	  var $headerNavi = $('.st-Header_Navi .globalnavi').find('a');
	  var $headerTrigger = $('.js-Trigger');
	  $headerTrigger.each(function () {
	    $(this).on('click', function () {
	      $(this).parent().toggleClass('opened');
	      $(this).siblings().slideToggle(200);
	      // $headerNavi.slideToggle(300, 'swing');
	      return false;
	    });
	  });
	};
	
	//外部ページからのアンカー
	var externalAnchor = function externalAnchor() {
	  setTimeout(function () {
	    var url = $(location).attr('href');
	    if (url.indexOf("?id=") == -1) {} else {
	      var url_sp = url.split("?id=");
	      var hash = '#' + url_sp[url_sp.length - 1];
	      var tgt = $(hash);
	      var pos = void 0;
	      if (windowWidth > breakPoint) {
	        pos = tgt.offset().top;
	      } else {
	        if (hash == '#system') {
	          pos = tgt.offset().top - windowWidth * 0.09765625;
	        } else {
	          pos = tgt.offset().top;
	        }
	      }
	      $("html, body").animate({
	        scrollTop: pos
	      }, 1000, "swing");
	    }
	  }, 1000);
	};
	
	//ページ内リンクのアニメーション
	var anchorScroll = function anchorScroll() {
	  var $anchor = $('a[href^=#]');
	  $anchor.click(function () {
	    var speed = 1000;
	    var href = $(this).attr('href');
	    var target = $(href == '#' || href == '' ? 'html' : href);
	    var position = target.offset().top;
	    $('html, body').animate({
	      scrollTop: position
	    }, speed, 'swing');
	    return false;
	  });
	};
	
	// Headerスクロール時
	var scrolledHeader = function scrolledHeader() {
	  var $header = $('.st-Header');
	  $(window).scroll(function () {
	    if ($(this).scrollTop() > 100) {
	      $header.addClass('scrolled');
	    } else {
	      $header.removeClass('scrolled');
	    }
	  });
	};
	
	// preload
	var preload = function preload() {
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	};
	
	// resizing
	var resizing = function resizing() {
	  var timer = 0;
	  $(window).on('resize', function () {
	    $("body").addClass("resizing");
	    if (timer > 0) {
	      clearTimeout(timer);
	    }
	    timer = setTimeout(function () {
	      $("body").removeClass("resizing");
	    }, 100);
	  });
	};
	
	// アニメーション
	var animationFire = function animationFire() {
	  $(".js-Animation").each(function () {
	
	    var animationFlag = false;
	    var $target = $(this);
	
	    $(window).on('load scroll', function () {
	      setTimeout(function () {
	        var winScroll = $(window).scrollTop();
	        var winHeight = $(window).height();
	        var scrollPositon = winScroll + winHeight;
	
	        if ($target.offset().top < scrollPositon) {
	          if (!animationFlag) {
	
	            animationFlag = true;
	
	            $target.addClass("animated");
	
	            // var $textEffect = $target.find('.textillate');
	            // if($textEffect){
	            //   $textEffect.textillate();
	            // }
	
	            var $textShuffle = $target.find('.shuffleeffect');
	            if ($textShuffle) {
	              $textShuffle.each(function (i) {
	                $(this).shuffleEffect(100);
	              });
	            }
	          }
	        }
	      }, 500);
	    });
	  });
	};
	
	//モーダル
	var closeModal = function closeModal() {
	  var $modal = $('.js-Modal');
	  var $close = $('.js-Modal .close');
	  $('.js-Modal .close').on('click', function () {
	    $modal.stop().fadeOut(400);
	  });
	};
	
	//YouTubeのモーダル
	var youtubeModal = function youtubeModal() {
	  var $modal = $('.sw-Movie_Modal');
	  var $content = $('.sw-Movie_Modal-Content');
	  var $youtube = $('.js-Youtube');
	  // open
	  $youtube.on('click', function () {
	    $(this).blur();
	    var dataID = $(this).attr('data-youtube');
	    //iframe append
	    $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
	    // fadeIn
	    $modal.stop().fadeIn(400);
	    return false;
	  });
	  //close
	  $('.sw-Movie_Modal-Overlay,.sw-Movie_Modal-Close').on('click', function () {
	    $modal.stop().fadeOut(400, function () {
	      $content.children('iframe').remove();
	    });
	  });
	};
	
	//export
	exports.loading = loading;
	exports.headerToggle = headerToggle;
	exports.externalAnchor = externalAnchor;
	exports.anchorScroll = anchorScroll;
	exports.scrolledHeader = scrolledHeader;
	exports.preload = preload;
	exports.resizing = resizing;
	exports.animationFire = animationFire;
	exports.closeModal = closeModal;
	exports.youtubeModal = youtubeModal;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// story/app.bundle.js